/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import fire from "firebase";
import SlideUp from "./slideUp";

const SocialStories = ({ deleteItem, user }) => {
  const { email } = user;
  console.log(email);
  const [loading, setLoading] = useState(false);
  const [blastItems, setblastItems] = useState([]);

  const socialRef = fire
    .firestore()
    .collection("blast")
    .where("category", "==", "Social Stories");

  function getItems() {
    setLoading(true);
    socialRef.onSnapshot((querySnapshot) => {
      const items = [];
      querySnapshot.forEach((doc) => {
        items.push(doc.data());
      });
      setblastItems(items);
      setLoading(false);
    });
  }

  useEffect(() => {
    getItems();
  }, []);

  if (loading) {
    return (
      <div className="loaderWindow">
        <div className="loader"></div>
      </div>
    );
  }

  return (
    <>
      <SlideUp />

      <h2>Social Stories</h2>
      <ul>
        {blastItems.map((blastItem) => (
          <li key={blastItem.id}>
            <div className="box inScreen">
              {email === "we2b@jsaweb.com" ? (
                <button
                  className="deleter_3up"
                  onClick={() => deleteItem(blastItem)}
                >
                  X
                </button>
              ) : null}

              <div className="imagePreview">
                <img src={blastItem.image_preview} alt={blastItem.image_name} />
              </div>
              <div className="info">
                <button
                  type="button"
                  onClick={(e) => {
                    e.preventDefault();
                    window.open(`https://${blastItem.link}`, "_blank");
                  }}
                >
                  Download Assets
                </button>
              </div>
            </div>
          </li>
        ))}
      </ul>
    </>
  );
};

export default SocialStories;
